import { render, staticRenderFns } from "./SponsorSignup.vue?vue&type=template&id=24b0b8d4&scoped=true"
import script from "./SponsorSignup.vue?vue&type=script&lang=js"
export * from "./SponsorSignup.vue?vue&type=script&lang=js"
import style0 from "./SponsorSignup.vue?vue&type=style&index=0&id=24b0b8d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b0b8d4",
  null
  
)

export default component.exports